import React from 'react';
import { I18n } from 'react-redux-i18n';

import CardHeader from 'components/CardHeader';
import ExportButton from 'components/Export';
import Select from 'components/Select';

import { getNameNetwork } from 'modules/Prices/helpers';
import { Option } from 'interface';

const PriceMarketHeader = ({
  exportName, // type: string
  network, // type: string
  markets, // type: array of strings
  handleNetwork,
  setMarkets,
  options // type: object with keys: networks, markets
}: {
  network: string | null;
  markets: string[];
  options: {
    networks: string[];
    markets: string[];
  };
  exportName: string | null;
  // eslint-disable-next-line no-unused-vars
  handleNetwork: (e: string) => void;
  // eslint-disable-next-line no-unused-vars
  setMarkets: (e: string[]) => void;
}) => {
  return (
    <>
      <CardHeader
        title={I18n.t('prices.price.allMarketsTitle')}
        fontSize="20px"
        alignItems="center"
        iconRight
        iconColor="#e25d34"
        rightComponents={
          <ExportButton
            jpg
            pdf
            targetElement="#prices-price"
            name={`${exportName} - I18n.t('prices.price.allMarketsTitle')`}
          />
        }
        styles={`.cardHeader{white-space:normal;max-width:50%}`}
      />

      <div className="ignored-export selectsContainer">
        <Select
          label={I18n.t('prices.filters.network')}
          placeholder=""
          value={
            network ? { label: network, value: getNameNetwork(network) } : null
          }
          onChange={(value: Option) => handleNetwork(value.value)}
          options={options.networks.map(
            (network): Option => ({
              label: getNameNetwork(network),
              value: network
            })
          )}
          dropdownProps={{
            styles: `margin-left:-25px`
          }}
        />
        <Select
          label={I18n.t('prices.filters.market')}
          placeholder="Sélectionner des réseaux"
          minWidth="170px"
          isMulti
          value={
            markets
              ? markets.map((market) => ({ value: market, label: market }))
              : []
          }
          dropdownProps={{
            styles: `margin-left:20px;margin-right:20px;`
          }}
          customStyles={{
            valueContainer: {
              overflowY: 'auto',
              maxHeight: '45px'
            }
          }}
          onChange={(value: Option[]) => {
            const markets = (
              value && value.length > 7 ? value.slice(1, value.length) : value
            ).map((item: Option) => item.value);
            setMarkets(markets);
          }}
          options={options.markets.map(
            (market): Option => ({
              label: market,
              value: market
            })
          )}
        />
      </div>
    </>
  );
};

export default PriceMarketHeader;
